import { Component } from '@angular/core';

@Component({
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent {}
